<template>
  <div class="main-content">
    <Header />
    <div class="side-nav">
      <Sidebar :item="item" />
    </div>
    <div class="content">
      <div class="createhmo">
        <p>
          <span class="createhmo__back">
            <routerLink to="/benefits">Benefits</routerLink>
          </span>
          >
          <span class="createhmo__current">Benefits Summary</span>
        </p>
        <div class="createhmo__container">
          <p>Create New HMO</p>
          <div class="createhmo__container--content">
            <div class="createhmo__container--content-header">
              <div>
                <img
                  src="./../../../assets/images/hospital.svg"
                  alt="hospital"
                />
              </div>
              <p>Let's Bring The HMO Onboard</p>
            </div>
            <div class="createhmo__container--content-body">
              <p>Basics</p>
              <div class="form-body-row">
                <div class="createhmo__container--content-body-form">
                  <label>HMO Provider Name</label>
                  <div>
                    <input
                      v-model.trim="formData.provider"
                      type="text"
                      placeholder="Name"
                    />
                  </div>
                </div>
                <div class="createhmo__container--content-body-form">
                  <label>Office Address</label>
                  <div>
                    <input
                      v-model.trim="formData.office_address"
                      type="text"
                      placeholder="Address"
                    />
                  </div>
                </div>
              </div>

              <div class="form-body-row">
                <div class="createhmo__container--content-body-form">
                  <label>Company Email Address</label>
                  <div>
                    <input
                      v-model.trim="formData.email"
                      type="text"
                      placeholder="Email Address"
                    />
                  </div>
                </div>
                <div class="createhmo__container--content-body-form">
                  <label>Contact Person</label>
                  <div>
                    <input
                      v-model.trim="formData.contact_person"
                      type="text"
                      placeholder="Name of contact person"
                    />
                  </div>
                </div>
              </div>

              <div class="form-body-row">
                <div class="createhmo__container--content-body-form">
                  <label>Phone Number</label>
                  <div>
                    <input
                      v-model.trim="formData.phone_1"
                      type="text"
                      placeholder="Phone number"
                    />
                  </div>
                </div>
                <div class="createhmo__container--content-body-form">
                  <label>Alternate Phone Number</label>
                  <div>
                    <input
                      v-model.trim="formData.phone_2"
                      type="text"
                      placeholder="Alternate phone number"
                    />
                  </div>
                </div>
              </div>

              <div class="form-body-row">
                <div class="createhmo__container--content-body-form">
                  <label>Website</label>
                  <div>
                    <input
                      v-model.trim="formData.website"
                      type="text"
                      placeholder="www.example.com"
                    />
                  </div>
                </div>
                <!-- <div class="createhmo__container--content-body-image">
                  <div>
                    <div v-show="!uploadedFile">
                      <img src="./../../../assets/images/upload.svg" alt="upload" />
                    </div>
                    <p v-show="!uploadedFile">upload HMO logo</p>
                    <img
                      v-bind:src="previewImage"
                      v-bind:alt="uploadedFileName"
                      v-show="uploadedFile"
                    />
                    <input type="file" ref="hmo" @change="getHmoLogo" />
                  </div>
                </div>-->
              </div>
            </div>
            <div class="createhmo__container--content-body">
              <p>HMO Plan(s) Setup</p>

              <template v-for="(plan, index) in formData.plans">
                <div :key="index">
                  <div class="form-body-row">
                    <div class="createhmo__container--content-body-form">
                      <label>Name of Plan</label>
                      <div>
                        <input
                          v-model.trim="plan.name"
                          type="text"
                          placeholder="Name of plan"
                        />
                      </div>
                    </div>
                    <div class="createhmo__container--content-body-form">
                      <label
                        >Plan Cover (enter link to plan cover details; pdf or
                        website)</label
                      >
                      <div>
                        <input
                          v-model.trim="plan.details"
                          type="text"
                          placeholder="www.example.com/easycare"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="form-body-row">
                    <div class="createhmo__container--content-body-form">
                      <label>Plan Price</label>
                      <div>
                        <input
                          v-model.trim="plan.price"
                          @keyup="formartPlanPrice(index)"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </template>

              <div class="form-body-row">
                <div
                  class="createhmo__container--content-body-btn"
                  @click="addPlan()"
                >
                  <font-awesome-icon icon="plus" />&nbsp; Add more plans under
                  this HMO?
                </div>
              </div>

              <div>
                <div class="error">
                  <div v-if="serverErrors">
                    <p
                      v-for="(value, name, index) in serverErrors"
                      :key="index"
                    >
                      {{ value[0] }}
                    </p>
                  </div>

                  <p v-if="dataSaveError">{{ dataSaveError }}</p>

                  <div v-if="emptyFields.length">
                    <p v-for="(field, index) in emptyFields" :key="index">
                      The {{ field }} input is required
                    </p>
                  </div>
                </div>
              </div>

              <div class="d-flex">
                <div class="btn">
                  <button @click.prevent="saveHmo()" v-show="!loading">
                    &nbsp; Save
                  </button>
                  <div v-show="loading">
                    <WhiteLoader />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import * as types from "../../../store/constant";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "CreateHMO",
  components: {
    Header,
    Sidebar,
    WhiteLoader,
  },
  data() {
    return {
      item: "benefit",
      uploadedFile: false,
      file: "",
      fileName: "",
      uploadedFileName: "",
      previewImage: "",

      formData: {
        provider: "",
        website: "",
        logo: "https://cdn.dailytrust.com.ng/wp-content/uploads/2018/10/AXA-Mansard-Plc-600x315.jpg",
        contact_person: "",
        office_address: "",
        phone_1: "",
        phone_2: "",
        email: "",
        plans: [
          {
            name: "",
            price: "",
            details: "",
          },
        ],
      },

      serverErrors: null,
      emptyFields: [],
      dataSaveError: "",

      loading: false,
    };
  },
  methods: {
    getHmoLogo() {
      this.fileName = this.$refs.hmo;
      this.file = this.$refs.hmo.files[0];
      const ext = this.fileName.value.split(".").pop();

      if (
        ext.toLowerCase().trim() === "png" ||
        ext.toLowerCase().trim() === "jpg"
      ) {
        if (this.file) {
          this.uploadedFile = true;
          this.uploadedFileName = this.fileName.value.split("\\").pop();
          this.previewImage = URL.createObjectURL(this.file);
        }
        return;
      }
      this.uploadedFile = false;
      return;
    },

    addPlan() {
      this.formData.plans.push({
        name: "",
        price: "",
        details: "",
      });
    },

    removeUnfilledInputs() {
      let plans = this.formData.plans.filter((plan) => {
        if (plan.price && plan.name && plan.details) {
          return true;
        }
      });

      this.formData.plans = plans;
    },

    validate() {
      let flag = true;
      let data = { ...this.formData };

      const vm = this;
      function trim(data) {
        for (var key in data) {
          if (typeof data[key] === "string") {
            const value = data[key];

            if (!value) {
              flag = false;
              vm.emptyFields.push(key);
            }
          }
        }
      }

      trim(data);

      return flag;
    },

    formartPlanPrice(index) {
      if (+this.formData.plans[index].price.replace(/,/g, "")) {
        this.formData.plans[index].price = parseInt(
          this.formData.plans[index].price.replace(/,/g, ""),
          10
        )
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        this.formData.plans[index].price = this.formData.plans[
          index
        ].price.substring(0, this.formData.plans[index].price.length - 1);
      }
    },

    saveHmo() {
      this.serverErrors = null;
      this.emptyFields = [];
      this.dataSaveError = "";

      if (!this.validate()) {
        return;
      }

      const atLeastOnePlan = this.formData.plans.some((plan) => {
        if (plan.price && plan.name && plan.details) {
          return true;
        }
      });

      if (!atLeastOnePlan) {
        this.dataSaveError =
          "Please fil in all the details for atleast one plan.";
        return;
      }

      this.removeUnfilledInputs();

      const plans = [...this.formData.plans];
      for (let i = 0; i < plans.length; i++) {
        let plan = plans[i];

        if (!plan.price.replace(/,/g, "").match(/^[0-9]+$/)) {
          this.dataSaveError = "The plan price should contain numbers only";
          return;
        }
      }

      for (let i = 0; i < this.formData.plans.length; i++) {
        this.formData.plans[i].price = parseInt(
          this.formData.plans[i].price.replace(/,/g, ""),
          10
        );
      }

      this.loading = true;
      this.$http
        .post(types.GET_HMOS_API, this.formData)
        .then(() => {
          this.$router.push("/benefits");
        })
        .catch((err) => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-content {
  display: flex;
  max-width: 2000px;
  margin: 0 auto;

  .side-nav {
    margin-top: 7rem;
    width: 15%;

    @media (max-width: 768px) {
      display: none;
    }
  }

  .content {
    margin-top: 4rem;
    background: #fbfafa;
    height: 100vh;

    @media (max-width: 768px) {
      margin-top: 4rem;
    }
  }

  @media (max-width: 768px) {
    .main-content {
      flex-direction: column;
      padding: 0;
    }
  }
}
.createhmo {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;
  padding-bottom: 100px;

  .endbutton {
    display: flex;
    width: 320px;
    margin-left: 28%;
    .savebutton {
      background-color: #5099de;
    }
  }

  .error {
    margin-top: 20px;
    margin-bottom: 20px;
    text-align: center;
    color: red;
    font-size: 0.938rem;
    font-style: italic;
  }

  .error > p {
    margin: 0;
  }

  .btn {
    margin-top: 10px;
    margin-bottom: 26px;
    width: 300px;
    margin: auto;
  }

  .btn > button {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    cursor: pointer;
  }

  .btn > div {
    border-radius: 2px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    background-color: #5099de;
    height: 55px;
    border: none;
    outline: none;
    color: #fff;
    font-size: 0.938rem;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.22;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    padding-top: 15px;
  }

  > p {
    font-size: 0.938rem;
    font-weight: 200;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.67;
    letter-spacing: normal;
    text-align: left;

    > .createhmo__back {
      a {
        color: #5099de;
        text-decoration: none;
      }
    }

    > .createhmo__current {
      color: #707070;
    }
  }

  .createhmo__container {
    border-radius: 2px;
    padding-top: 20px;
    padding-bottom: 80px;

    > p {
      font-size: 2.083rem;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.18;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
      margin: 0;
    }

    .createhmo__container--content {
      border-top: 1px solid #caced5;
      padding: 50px 5px;

      > .createhmo__container--content-header {
        margin-bottom: 50px;
        > div {
          width: 4.583vw;
          margin: auto;
        }

        > p {
          font-size: 1.458rem;
          font-weight: 600;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.07;
          letter-spacing: normal;
          text-align: center;
          color: #000000;
          margin-top: 30px;
        }
      }

      > .createhmo__container--content-body {
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        padding: 20px 20px 50px 20px;
        margin-bottom: 50px;

        > p {
          font-size: 1.25rem;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.67;
          letter-spacing: normal;
          text-align: left;
          color: #5099de;
        }

        .form-body-row {
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;
          padding-right: 5.208vw;

          @media (max-width: 768px) {
            flex-direction: column;
            padding: 0;
          }

          > .createhmo__container--content-body-form {
            max-width: 27.24rem;

            #plan-price {
              padding-left: 43px;
            }

            > label {
              font-size: 0.938rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 2.22;
              letter-spacing: normal;
              text-align: left;
              color: #000000;
            }

            > div {
              height: 40px;
              border: solid 1px #c7c7c7;
              background-color: #ffffff;
              overflow: hidden;
              position: relative;

              > input {
                height: 40px;
                font-size: 0.833rem;
                font-weight: 200;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.5;
                letter-spacing: normal;
                text-align: left;
                color: #777777;
                border: 0;
                outline: 0;
                padding-left: 10px;
                padding-right: 10px;
              }

              > p {
                position: absolute;
                top: 0;
                left: 0;
                width: 40px;
                height: 40px;
                font-size: 1rem;
                font-weight: 200;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.5;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                align-items: center;
                justify-content: center;
                align-content: center;
                border-right: solid 1px #c7c7c7;
                background-color: #fafafa;
              }
            }
          }

          > .createhmo__container--content-body-image {
            max-width: 27.24vw;

            > div {
              max-width: 14.115vw;
              height: 100px;
              border: dotted 1px #5099de;
              background-color: #ffffff;
              cursor: pointer;
              position: relative;
              overflow: hidden;

              > div {
                width: 1.146vw;
                margin: 20px auto 0 auto;
              }

              > p {
                font-size: 0.938rem;
                font-weight: 200;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.22;
                letter-spacing: normal;
                text-align: center;
                color: #5099de;
              }

              > input {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: red;
                opacity: 0;
                cursor: pointer;
              }

              > img {
                width: 100%;
              }
            }
          }

          > .createhmo__container--content-body-btn {
            height: 50px;
            margin-top: 20px;
            border: dotted 1px #5099de;
            background-color: #ffffff;
            font-size: 0.938rem;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.22;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
